import { Input, ButtonPrimaryCustom } from '../../../component/input/InputLogin';
import Login from '../interfaces/Login';
import { FormInterface } from '../../../core/interfaces/form/Form';
import { useFormik } from 'formik';

export default function Form({ handleSubmitForm, initialValues, request }: FormInterface<Login>) {

    const { handleSubmit, handleChange, isSubmitting } = useFormik<Login>({
        initialValues: initialValues,
        onSubmit: values => {
            handleSubmitForm(values);
        },
    });

    return (
        <form onSubmit={handleSubmit}>

              <Input
                type="text"
                placeholder="Usuário"
                name="user"
                onChange={handleChange}
                required
                first
              />
              <Input
                type="password"
                placeholder="Senha"
                name="pass"
                onChange={handleChange}
                required
              />

            {isSubmitting && request ? <ButtonPrimaryCustom type="submit" className="btnDisable">Carregando...</ButtonPrimaryCustom> : <ButtonPrimaryCustom type="submit">Entrar</ButtonPrimaryCustom> }
        </form>
    )
}
